import React, { useState } from "react";
import { useI18n } from "../../i18n/i18n";
import { Card, CardContent, CardHeader, CardTitle } from "../card";
import { UtilityTypeTabs } from "../utility-type-tabs";

export const ConsumptionView = ({ houseId }: { houseId: number | null }) => {
  const { t } = useI18n();
  const [activeTab, setActiveTab] = useState<"electricity" | "water">("electricity");

  if (!houseId) {
    return (
      <Card>
        <CardHeader>
          <CardTitle>{t("consumption.title", "Consumption")}</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-muted">
            {t("consumption.selectHouse", "Select a house to review consumption.")}
          </p>
        </CardContent>
      </Card>
    );
  }

  return (
    <div className="space-y-6">
      <div>
        <p className="text-lg font-semibold text-ink">{t("consumption.title", "Consumption")}</p>
        <p className="text-sm text-muted">{t("consumption.subtitle", "Consumption page reset in progress.")}</p>
      </div>

      <UtilityTypeTabs
        activeType={activeTab}
        onChange={setActiveTab}
        electricityLabel={t("consumption.electricity", "Electricity")}
        waterLabel={t("consumption.water", "Water")}
      />

      <Card>
        <CardHeader>
          <CardTitle>
            {activeTab === "electricity"
              ? `${t("consumption.electricity", "Electricity")} (kWh)`
              : `${t("consumption.water", "Water")} (m3)`}
          </CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-muted">{t("consumption.noPeriods", "No content yet.")}</p>
        </CardContent>
      </Card>
    </div>
  );
};
